function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersona(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.165,
    height: 89.973,
    viewBox: "0 0 80.165 89.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Vrstva_436",
    "data-name": "Vrstva 436",
    transform: "translate(1 1.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_545",
    d: "M41.083 8.568a11.725 11.725 0 1 0 11.724 11.725A11.725 11.725 0 0 0 41.083 8.568zM2 71.1a39.083 39.083 0 0 1 25.56-36.7 19.541 19.541 0 1 1 13.523 5.432A31.266 31.266 0 0 0 9.817 71.1v3.908a3.908 3.908 0 0 1-7.817 0zm39.083-5.862a15.633 15.633 0 1 1 15.633 15.633 15.633 15.633 0 0 1-15.633-15.633zm15.633-23.45a23.45 23.45 0 1 0 23.45 23.45 23.45 23.45 0 0 0-23.45-23.45zM67.932 62.15a3.98 3.98 0 0 0-5.55-5.706l-8.832 8.989-2.423-2.619a3.927 3.927 0 1 0-5.745 5.354l4.612 5.042a4.729 4.729 0 0 0 6.8 0z",
    "data-name": "Trazado 545",
    transform: "translate(-2 -.749)",
    style: {
      fill: "#3f66b3",
      stroke: "#f7f8f9",
      strokeWidth: 2,
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersona);
export default __webpack_public_path__ + "static/media/Persona.967e51c9f2a44d99eb15b2396b9a4e55.svg";
export { ForwardRef as ReactComponent };